<template>
    <div class="share-manager">
        <p class="plugin-header">
            分享地图
        </p>
        <div class="share-panel share-link">
            <div class="share-panel-content">
                <div class="share-info-content">
                    <div class="pull-left">
                        <img src="https://assets-v3.changjing.com.cn/uploads/rqcode/dqDAe485X-mH_cY_B8Cjiw.png"
                            alt="Dqdae485x mh cy b8cjiw" width="80" height="80">
                        <p class="dt-f12 rqcode-text">链接二维码</p>
                    </div>
                    <div class="share-link-panel">
                        <table width="100%">
                            <tbody>
                                <tr>
                                    <td width="90%">
                                        <input id="shareUrl" type="text" class="pull-left share-url"
                                            value="https://zt.changjing.com.cn/map/viewer?mid=dqDAe485X-mH_cY_B8Cjiw">
                                    </td>
                                    <td>
                                        <a href="javascript:void(0)" data-clipboard-target="#shareUrl"
                                            class="btn btn-primary btn-xs copy-share-link">复制</a>
                                    </td>
                                </tr>
                                <tr>
                                    <th colspan="2"><span class="dt-show">复制链接或二维码分享地图</span></th>
                                </tr>
                                <tr>
                                    <td>
                                        <input id="embedUrl" type="text" class="pull-left share-url"
                                            value="<iframe  width='100%' height='100%' frameBorder='0' src='https://zt.changjing.com.cn/map/dqDAe485X-mH_cY_B8Cjiw/embed?base_map=normal&amp;center=113.559614399%2C22.954975329&amp;level=12'> </iframe>">
                                    </td>
                                    <td>
                                        <a href="javascript:void(0)" data-clipboard-target="#embedUrl"
                                            class="btn btn-primary btn-xs copy-share-link">复制</a>
                                    </td>
                                </tr>
                                <tr>
                                    <th colspan="2">
                                        <p><span class="dt-mar6t">复制JS代码，将地图嵌入网站</span></p>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="share-permission-content dt-hidden dt-mar12t">
                    <div class="dt-hidden">
                        <div class="dt-pad10x pull-left">
                            <input id="grpPermission" type="radio" value="grp" name="permission_radio">
                            <label for="grpPermission" class="dt-pointer dt-line-30h dt-normal">私有</label>
                        </div>
                        <div class="dt-pad10x pull-left">
                            <input id="pubPermission" type="radio" value="pub" name="permission_radio" checked="">
                            <label for="pubPermission" class="dt-pointer dt-line-30h dt-normal">公开</label>
                        </div>
                        <div class="dt-pad10x pull-left">
                            <input id="psdPermission" type="radio" value="psd" name="permission_radio">
                            <label for="psdPermission" class="dt-pointer dt-line-30h dt-normal">加密</label>
                            <span class="change-password dt-pointer color2e9 dt-none">修改密码</span>
                        </div>
                    </div>
                    <div class="password-input dt-none dt-pad10x">
                        <hr>
                        <input type="text" id="pwd" minlength="6" maxlength="6" class="form-control pull-left"
                            placeholder="输入6位密码" value="">
                        <span class="glyphicon glyphicon-ok" id="submitPas"></span>
                    </div>
                </div>
                <div class="share-download-content">
                    <label>允许访客下载数据</label>
                    <input type="checkbox" id="map_marker_selector_on" class="chk_4">
                    <label for="map_marker_selector_on" class="dt-middle pull-right"></label>
                    <div id="map-description">

                    </div>
                </div>
            </div>
        </div>

        <div class="share-panel map-act-permission">
            <div class="share-panel-title">
                下载导出
            </div>
            <div class="download-content">
                <div class="text-left dt-h34 dt-mar12b dt-line-30h">
                    <span class="select-layer">图层</span>
                    <select id="downloadLayers" class="form-control">
                        <option value="all">全部图层</option>
                        <option data-type="line_layer" value="329946">线路图层1</option>
                        <option data-type="marker_layer" value="2516209">品牌网点</option>
                        <option data-type="region_layer" value="1282377">品牌网点周边3km</option>
                        <option data-type="region_layer" value="1282376">格网分析 3km 汽配店</option>
                        <option data-type="region_layer" value="1282375">格网分析 5km 小区</option>
                        <option data-type="region_layer" value="1282374">东莞32个镇区潜力指数</option>
                    </select>
                </div>
                <div class="text-left dt-h34 dt-mar12b dt-line-30h">
                    <span class="select-layer">格式</span>
                    <select id="downloadType" class="form-control" disabled="disabled">
                        <option value="xls">xls</option>
                        <option value="csv">csv</option>
                        <option value="geojson">GeoJSON</option>
                    </select>
                </div>
                <div class="text-left dt-h34">
                    <label>是否带有系统字段</label>
                    <input type="checkbox" id="downloadSystemFields" class="chk_4" checked="">
                    <label for="downloadSystemFields" class="dt-middle pull-right"></label>
                </div>
                <div class="text-left dt-h34">
                    <a class="btn btn-primary btn-sm pull-right" id="dataDownloadBtn" href="###">下载</a>
                </div>
                <div class="text-left">
                    <span class="caption">提示:<br>若选择全部图层,下载格式统一为zip(xls)。<br>若选择单个图层,下载格式可以设置为xls<br>或者GeoJSON。</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ShareManager',
    components: {

    },
    data() {
        return {

        }
    },
    mounted() {


    },
    methods: {


    }
}

</script>

<style scoped>
.share-manager {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    scrollbar-width: none;
}

.plugin-header {
    height: 36px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #edf0f5;
    line-height: 36px;
    color: #576d8b;
}
.share-panel {
    position: relative;
    background-color: #fff;
    width: 282px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    margin-top: 12px;
}
.share-panel-content .rqcode-text {
    text-align: center;
    margin-top: 4px;
    color: #576d8b;
}
.dt-f12 {
    font-size: 12px;
}
p {
    margin: 0;
}
.share-panel-content .share-link-panel input {
    height: 24px;
    width: 120px;
    padding: 8px;
    border: none;
    outline: none;
    border-radius: 2px;
    font-size: 12px;
    background-color: #edf0f5;
    padding: 8px;
    color: #576d8b;
}
.pull-left {
    float: left !important;
}
.share-panel-content {
    margin-top: 12px;
    overflow: hidden;
}
.share-panel-content .share-info-content {
    overflow: hidden;
    padding: 0 10px;
}
.share-permission-content {
    color: #576d8b;
    overflow: hidden;
}
.pull-left {
    float: left !important;
}
.share-panel-content .share-link-panel {
    width: 65%;
    float: right;
}
.dt-hidden {
    overflow: hidden;
}
.dt-mar12t {
    margin-top: 12px;
}
.share-download-content, .download-content {
    padding: 0 10px;
    margin-top: 10px;
    overflow: hidden;
    margin-bottom: 10px;
    min-height: 30px;
    color: #576d8b;
}
.btn-primary {
    color: #ffffff;
    background-color: #428bca;
    border-color: #357ebd;
}
.btn-primary {
    background-color: #0095ff;
    border-color: #0095ff;
}
.btn-xs, .btn-group-xs>.btn {
    padding: 1px 5px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
}

.btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
 
    font-size: 14px;
    line-height: 1.42857143;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.share-panel-content .share-link-panel span {
    color: #42526b;
    display: inline-block;
    margin-bottom: 4px;
    font-weight: normal;
}
span {
    font-size: 12px;
}
.share-permission-content {
    color: #576d8b;
    overflow: hidden;
}
.dt-hidden {
    overflow: hidden;
}
.dt-mar12t {
    margin-top: 12px;
}
.dt-pad10x {
    padding-left: 10px;
    padding-right: 10px;
}

.pull-left {
    float: left !important;
}
.share-permission-content .password-input {
    position: relative;
    margin-bottom: 10px;
    overflow: hidden;
}
.dt-none {
    display: none;
}
.dt-pad10x {
    padding-left: 10px;
    padding-right: 10px;
}
.share-download-content, .download-content {
    padding: 0 10px;
    margin-top: 10px;
    overflow: hidden;
    margin-bottom: 10px;
    min-height: 30px;
    color: #576d8b;
}
.share-download-content label, .download-content label {
    font-size: 12px;
}
label {
    max-width: none;
}
label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: bold;
}


.share-download-content label, .download-content label {
    font-size: 12px;
}
.chk_4+label {
    cursor: pointer;
    background-color: #FFF;
    padding: 9px;
    border-radius: 16px;
    display: inline-block;
    position: relative;
    margin-right: 0;
    background: #ccc;
    width: 30px;
    height: 12px;
    box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.1), 0 0 10px rgba(200, 184, 184, 0.4);
}
.chk_4+label {
    cursor: pointer;
    background-color: #FFF;
    padding: 11px 9px;
    border-radius: 7px;
    display: inline-block;
    position: relative;
    margin-right: 0px;
    background: #ccc;
    width: 58px;
    height: 24px;
    box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.1), 0 0 10px rgba(200, 184, 184, 0.4);
}
.pull-right {
    float: right;
}
.pull-right {
    float: right;
}
.dt-middle {
    vertical-align: middle;
}
.pull-right {
    float: right;
}
.pull-right {
    float: right !important;
}
label {
    max-width: none;
}
label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: bold;
}
.share-download-content .chk_4+label, .download-content .chk_4+label {
    cursor: pointer;
    background-color: #FFF;
    padding: 9px;
    border-radius: 16px;
    display: inline-block;
    position: relative;
    margin-right: 0;
    background: #ccc;
    width: 30px;
    height: 12px;
    z-index: 0;
    box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.1), 0 0 10px rgba(200, 184, 184, 0.4);
}
.chk_4+label:before {
    content: ' ';
    position: absolute;
    background: #FFF;
    top: 0px;
    z-index: 100;
    left: 0px;
    width: 24px;
    color: #FFF;
    height: 24px;
    border-radius: 7px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.6);
}
.share-download-content .chk_4+label:before, .download-content .chk_4+label:before {
    content: ' ';
    position: absolute;
    background: #FFF;
    top: 0;
    z-index: 99999;
    left: 0;
    width: 18px;
    color: #FFF;
    height: 18px;
    border-radius: 16px;
    z-index: 0;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.6);
}
.chk_1, .chk_2, .chk_3, .chk_4 {
    display: none;
}
.share-panel-title {
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    padding: 0 10px;
    color: #576d8b;
    letter-spacing: 0;
    text-align: left;
    background: #edf0f5;
}
.share-download-content, .download-content {
    padding: 0 10px;
    margin-top: 10px;
    overflow: hidden;
    margin-bottom: 10px;
    min-height: 30px;
    color: #576d8b;
}
.text-left {
    text-align: left;
}
.dt-line-30h {
    line-height: 30px;
}
.dt-h34 {
    height: 34px;
}
.dt-mar12b {
    margin-bottom: 12px;
}
#downloadLayers, #downloadType {
    display: inline-block;
    width: 224px;
    margin-left: 10px;
}
.form-control {
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555555;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #cccccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
#downloadLayers, #downloadType {
    display: inline-block;
    width: 224px;
    margin-left: 10px;
}
.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    cursor: not-allowed;
    background-color: #eeeeee;
    opacity: 1;
}
.form-control {
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555555;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #cccccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
.btn-sm, .btn-group-sm>.btn {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
}
.share-download-content .caption, .download-content .caption {
    position: relative;
    display: inline-block;
    color: #aaa;
    font-weight: 400;
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>